import Vue from "vue";
import VueI18n from "vue-i18n";

import getLocale from "@/utils/locale";
import settingsApi from "@/api/settings";

import { dispatchExpectionToast } from "./utils";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLocale(),
  messages: { en: { "error-500": "Something went wrong. Please try again in a couple of minutes." }, de: { "error-500": "Etwas ist schief gelaufen. Bitte versuche es in ein paar Minuten nochmal." } }
});

const state = {
  emailPreferences: null,
  deleteAccount: {
    currentStep: null,
    loading: false,
    error: null,
    hasPassword: null
  }
};

const mutations = {
  currentStepDeleteAccount: (state, payload) => {
    Vue.set(state.deleteAccount, "currentStep", payload);
  },
  loadingDeleteAccount: (state, payload) => {
    Vue.set(state.deleteAccount, "loading", payload);
  },
  errorDeleteAccount: (state, payload) => {
    Vue.set(state.deleteAccount, "error", payload);
  },
  hasPasswordDeleteAccount: (state, payload) => {
    Vue.set(state.deleteAccount, "hasPassword", payload);
  },
  saveEmailPreferences: (state, payload) => {
    state.emailPreferences = payload;
  },
  updateEmailPreference: (state, { category, email, value }) => {
    state.emailPreferences[category][email].subscribed = value;
  }
};

const getters = {
  canDeleteAccount: (state, getters, rootState) => {
    return rootState.user.willRenew === false;
  },
  errorDeleteAccount: (state) => {
    return state.deleteAccount.error;
  },
  emailPreferences: (state) => {
    const subscribedStatus = state.emailPreferences.other.all.subscribed;

    const catrgoryArrays = Object.entries(state.emailPreferences).map((categoryArray) => {
      const [categoryName, emails] = categoryArray;

      const emailArrays = Object.entries(emails).map((emailArray) => {
        const [emailName, email] = emailArray;

        return [
          emailName,
          {
            ...email,
            subscribed: emailName === "subscription" || (subscribedStatus && email.subscribed),
            disabled: emailName === "subscription" || (emailName !== "all" && !subscribedStatus)
          }
        ];
      });

      return [categoryName, Object.fromEntries(emailArrays)];
    });

    return Object.fromEntries(catrgoryArrays);
  }
};

const actions = {
  deleteAccount: ({ commit }, password) => {
    commit("loadingDeleteAccount", true);
    settingsApi
      .deleteAccount(password)
      .then(res => {
        if (res.status === "error") {
          throw res.message;
        } else {
          commit("currentStepDeleteAccount", "success");
        }
      })
      .catch((err) => {
        commit("errorDeleteAccount", err);
      })
      .finally(() => {
        commit("loadingDeleteAccount", false);
      });
  },
  closeDeleteAccount: ({ commit }) => {
    commit("currentStepDeleteAccount", null);
  },
  loadEmailPreferences: async ({ commit, dispatch }) => {
    try {
      const settings = await settingsApi.loadEmailPreferences();
      commit("saveEmailPreferences", settings);
    } catch (e) {
      dispatchExpectionToast(dispatch, i18n);
      throw e;
    }
  },
  updateEmailPreference: async ({ commit, dispatch, state }, {
    category,
    email,
    value
  }) => {

    const oldValue = state.emailPreferences[category][email].subscribed;

    try {
      commit("updateEmailPreference", {
        category, email, value
      });

      if (value) {
        await settingsApi.addToList(email);
      } else {
        await settingsApi.removeFromList(email);
      }

    } catch (e) {
      dispatchExpectionToast(dispatch, i18n);
      commit("updateEmailPreference", {
        category, email, value: oldValue
      });
      throw e;
    }

  },
  updateEmailSubscriptionStatus: async ({ commit, dispatch }, { value }) => {

    try {
      commit("updateEmailPreference", {
        category: "other", email: "all", value
      });

      const status = value ? "opted_in" : "unsubscribed";
      await settingsApi.updateEmailSubscriptionStatus(status);

    } catch (e) {
      commit("updateEmailPreference", {
        category: "other", email: "all", value: !value ? "opted_in" : "unsubscribed"
      });

      dispatch("loadEmailPreferences");
      dispatchExpectionToast(dispatch, i18n);
      throw e;
    }

  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
